import React from 'react'
import { Link } from 'react-router-dom'
import { Avatar } from '@ztechapps/webui.util'
import { truncate } from '@ztechapps/common.utils'

export const BlogWidget = ({ title, summary, cover, linkTo }) => {
  return (
    <div className="d-flex">
      <div className="me-1 mr-1">
        <Avatar name={title} src={cover} size={40} />
      </div>
      <div>
        <Link to={linkTo}>
          <b>{title}</b>
        </Link>
        <br />
        <small>{truncate(summary, 150)}</small>
      </div>
    </div>
  )
}
